module.exports = __webpack_public_path__ + "static/cookie-b6d3d8883d03574c32a9e2189baafd0e.jpg";